// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1YBQw","col":"CardReaderDesc_col__2Enp4","label":"CardReaderDesc_label__3NjnJ"};